<template>
  <!-- 分成管理 -->
  <div class="receive-dividents">
    <!-- <div class="detailsTitle">
      <h4>分成管理</h4>
    </div> -->
    <!-- 查询条件 -->
    <div ref="searchBox" class="formBox margbot">
      <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData">
        <el-form-item label="分成时间:">
          <el-date-picker v-model="formData.divideTimeStart" size="mini" type="datetime" placeholder="开始时间" value-format="yyyy-MM-dd HH:mm:ss" style="width: 175px"></el-date-picker>
          -
          <el-date-picker v-model="formData.divideTimeEnd" size="mini" placeholder="结束时间" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 175px"></el-date-picker>
        </el-form-item>
        <el-form-item label="仓库名称:">
          <el-select v-model="formData.organizationName" size="mini" placeholder="请选择" filterable clearable>
            <el-option v-for="(item, index) in RKData" :key="index" :label="item.tenantName" :value="item.tenantName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分成状态:">
          <el-select v-model="formData.divideStatus" size="mini" placeholder="请选择" filterable clearable>
            <el-option v-for="item in dividendStatusData" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="帐单号:">
          <el-input type="text" v-model="formData.feeNo" style="width:175px;vertical-align:top;" size="mini" placeholder="请输入"></el-input>
        </el-form-item>
        <br />
        <el-form-item>
          <el-button type="primary" size="mini" @click="chaxun" v-if="btnFlg[0]">查询</el-button>
          <el-button type="primary" size="mini" @click="chongzhi" v-if="btnFlg[1]">重置</el-button>
          <el-button type="primary" size="mini" @click="daochu" v-if="btnFlg[2]">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{ height: h }">
      <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref1" :data="tableData" style="width: 100%" class="tableComent">
        <el-table-column type="index" width="60" label="序号"></el-table-column>
        <el-table-column label="操作" width="100">
          <template #default="scope">
            <el-button type="text" v-if="btnFlg[3]" @click="detail(scope.row)" size="mini">账单明细</el-button>
          </template>
        </el-table-column>
        <el-table-column v-for="item in columns" :key="item.prop" :prop="item.prop" :label="item.label" :width="item.width" :formatter="item.formatter">
        </el-table-column>
      </el-table>
      <div class="pags" style="text-align: right">
        <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo" :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"></el-pagination>
      </div>
    </div>
    <billsDetail v-if="zhangdanDetailVisible" :zhangdanDetailVisible.sync="zhangdanDetailVisible" :inventoryDivideId="inventoryDivideId"></billsDetail>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import columns from './receiveDtableColumn'
import { exportExcel } from '@/utils/fileDown.js'
import { getAllTenantData } from '@/api/platform-settlement'
import billsDetail from './billsDetail.vue'
import {
  getDivideFeeList
} from '@/api/wms-stock'
export default {
  name: 'receiveDividends',
  components: { billsDetail },
  mixins: [columns],
  data () {
    return {
      formData: {
        divideTimeStart: '',
        divideTimeEnd: '',
        organizationName: '',
        divideStatus: '',
        feeNo: ''
      },
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      total: 0,
      RKData: [],
      dividendStatusData: [
        { name: '未分账' },
        { name: '已分账' }
      ],
      btnFlg: [],
      btnArr: [
        '0130020100',
        '0130020200',
        '0130020300',
        '0130020400'
      ],
      h: '500px',
      tableData: [],
      zhangdanDetailVisible: false,
      inventoryDivideId: ''
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/receiveDividends')
    this.chaxun()
    this.getAllTenantData()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 165 + 'px'
  },
  methods: {
    getAllTenantData () {
      getAllTenantData()
        .then(res => {
          console.log(res)
          this.RKData = res
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    chaxun () {
      getDivideFeeList({ ...this.formData, ...this.pageInfo })
        .then(res => {
          console.log(res)
          this.tableData = res.list
          this.total = res.total
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    chongzhi () {
      this.formData = {
        divideTimeStart: '',
        divideTimeEnd: '',
        organizationName: '',
        divideStatus: '',
        feeNo: ''
      }
      this.chaxun()
    },
    // 导出
    daochu () {
      exportExcel(
        this.global.wmsStockName + '/inventory/exportDivideFeeList',
        this.formData,
        '分成查询表'
      )
    },
    detail (row) {
      this.zhangdanDetailVisible = true
      this.inventoryDivideId = String(row.inventoryDivideId)
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.chaxun()
    }
  }
}
</script>
<style lang='less' scoped>
/deep/.el-form-item {
  margin-bottom: 0;
}
</style>
